import $ from 'jquery';
import { closeModal } from '@/functions/function.js';

export default {
    name: 'articles',
    components: {},
    props: [],
    data () {
      return {
          fields: ['nom','description', 'responsable', 'actions'],
          filter: "",
          loading: false,
          perPage: 30,
          currentPage: 1,
          stock: {},
          autorisation: false,
          personnalStocks: [],
      }
    },
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        stocks() {
            return this.$store.getters['stocks']
        },

        users() {
            return this.$store.getters['users']
        }
     
    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.$store.dispatch("getStocks").then(
            this.checkRole()
        );
        this.$store.dispatch("getUsers");


    },
    methods: {

        getUser(id) {
            var user= "" 

            this.users.forEach(
                element => {
                    if(element.id == id) {
                        user = element.name
                    } 
                }
            );
            return user
        },

        setStock(data) {
            this.$set(this.stock, 'id', data.id)
            this.$set(this.stock, 'description', data.description)
            this.$set(this.stock, 'nom', data.nom)
            this.$set(this.stock, 'utilisateur', data.utilisateur_id)

        },

        async updateStock() {
            this.loading=true
            const data = {
                nom:  this.stock.nom,
                description:  this.stock.description,
                utilisateur_id:  this.stock.utilisateur,

            }   
    
            await this.$store.dispatch("editStock",{ 
                id:this.stock.id , 
                data: data 
            }).then(
                response => {
    
                    if (response) {
                        this.$refs.close_update.click()
                    } 
                }
            );
    
            this.loading=false
    
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        },

        checkRole () {

            //Verification si utilisateur est admin ou pharmacienne
            this.userCredentials.user.roles.forEach(
                element => {
                    if(element.id == 1 || element.id == 6 ) {
                        this.autorisation = true
                    } 
                }
            );
    
            //S'il n'a paq autorisation afficher que ses stocks
            if (!this.autorisation) {
                this.stocks.forEach(
                    element => {
                        
                        if(this.userCredentials.user.id == element.utilisateur_id ) {
                            this.personnalStocks.push(element)
                        } 
                    }
                );


            }

            return this.autorisation
        }
    }
  }
  
  
  